import { Injectable } from '@angular/core';
import { GetPaymentInstrumentsResponse, WPayCheckoutSessionResponse } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AppSettingsService } from './app-settings.service';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PaymentInstrumentsService {
	constructor(
		private appSettingsService: AppSettingsService,
		private apiService: ApiService
	) {}

	deleteInstrument(instrumentId: string): Observable<HttpResponse<unknown>> {
		return this.apiService.deleteWithFullResponse(
			`${this.appSettingsService.getEndpoint('paymentInstruments')}/${instrumentId}`
		);
	}

	getSavedInstruments(): Observable<GetPaymentInstrumentsResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('paymentInstruments'));
	}

	getWPaySavedInstruments(): Observable<GetPaymentInstrumentsResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('wPayPaymentInstruments'));
	}

	getNewWPayCheckoutSession(): Observable<WPayCheckoutSessionResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('newWpayCheckoutSession'));
	}

	deleteWPayInstrument(instrumentId: string): Observable<HttpResponse<unknown>> {
		return this.apiService.deleteWithFullResponse(
			`${this.appSettingsService.getEndpoint('wPayPaymentInstruments')}/${instrumentId}`
		);
	}
}
